<template>
  <div>
    <div
      class="modal fade"
      :ref="`modal-asset-in-activity-detail`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t(modalTitle) }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <label for="name" class="control-label required"
                  >{{ $t("property.asset.name") }}:
                </label>
                <span>{{ assetData.name }}</span>
              </div>
              <div class="col-md-12">
                <label for="name" class="control-label required"
                  >{{ $t("property.asset.location") }}:
                </label>
                <span>{{ assetData.location }}</span>
              </div>
              <div class="col-md-12">
                <label for="name" class="control-label required"
                  >{{ $t("property.asset.type") }}:
                </label>
                <span>{{ assetData.type }}</span>
              </div>
              <div class="col-md-12">
                <label for="name" class="control-label required"
                  >{{ $t("propertyMaintenance.lastImplementationeDate") }}:
                </label>
                <span>{{ assetData.lastImplementationeDate }}</span>
              </div>
              <div class="col-md-12">
                <label for="name" class="control-label required"
                  >{{ $t("propertyMaintenance.nextImplementationDate") }}:
                </label>
                <span>{{ assetData.nextImplementationDate }}</span>
                <hr style="margin-top: 7.5px; margin-bottom: 7.5px;" />
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <div
                    style="width: fit-content; display: flex;"
                    @click="isShowOriginDetail = !isShowOriginDetail"
                  >
                    <label for="name" class="control-label required"
                      >{{ $t("property.asset.originDetail") }}
                    </label>
                    <div style="padding-left: 5px">
                      <i
                        v-if="isShowOriginDetail"
                        class="glyphicon glyphicon-chevron-down"
                      ></i>
                      <i v-else class="glyphicon glyphicon-chevron-up"></i>
                    </div>
                  </div>
                  <div v-if="isShowOriginDetail">
                    <div class="col-md-12">
                      <label for="location" class="control-label"
                        >{{ $t("property.asset.origin") }}:</label
                      >
                      <span>{{ assetData.origin }}</span>
                    </div>
                    <div class="col-md-12">
                      <label for="location" class="control-label"
                        >{{ $t("property.asset.provider") }}:</label
                      >
                      <span>{{ assetData.provider }}</span>
                    </div>
                    <div class="col-md-12">
                      <label for="location" class="control-label"
                        >{{ $t("property.asset.assetContactPerson") }}:</label
                      >
                      <span>{{ assetData.assetContactPerson }}</span>
                    </div>
                    <div class="col-md-12">
                      <label for="location" class="control-label"
                        >{{ $t("property.asset.model") }}:</label
                      >
                      <span>{{ assetData.assetModel }}</span>
                    </div>
                    <div class="col-md-12">
                      <label for="location" class="control-label"
                        >{{ $t("property.asset.seriCode") }}:</label
                      >
                      <span>{{ assetData.seriCode }}</span>
                    </div>
                    <div class="col-md-12">
                      <label for="location" class="control-label"
                        >{{ $t("property.asset.guaranteePeriod") }}:</label
                      >
                      <span>{{ assetData.guaranteePeriod }}</span>
                    </div>
                    <div class="col-md-12">
                      <label for="location" class="control-label"
                        >{{ $t("property.asset.propertyReceiptDate") }}:</label
                      >
                      <span>{{ assetData.propertyReceiptDate }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <div
                    style="width: fit-content; display: flex;"
                    @click="isShowUseInformation = !isShowUseInformation"
                  >
                    <label for="name" class="control-label required"
                      >{{ $t("property.asset.useInformation") }}
                    </label>
                    <div style="padding-left: 5px">
                      <i
                        v-if="isShowUseInformation"
                        class="glyphicon glyphicon-chevron-down"
                      ></i>
                      <i v-else class="glyphicon glyphicon-chevron-up"></i>
                    </div>
                  </div>
                  <div v-if="isShowUseInformation">
                    <div class="col-md-12">
                      <label for="location" class="control-label"
                        >{{ $t("property.asset.unitsUsed") }}:</label
                      >
                      <span>{{ assetData.unitsUsed }}</span>
                    </div>
                    <div class="col-md-12">
                      <label for="location" class="control-label"
                        >{{ $t("property.asset.status") }}:</label
                      >
                      <span>{{ assetData.status }}</span>
                    </div>
                    <div class="col-md-12">
                      <label for="location" class="control-label"
                        >{{ $t("property.asset.assetUsers") }}:</label
                      >
                      <span>{{ assetData.assetUsers }}</span>
                    </div>
                  </div>
                </div>
                <hr style="margin-top: 7.5px; margin-bottom: 7.5px;" />
              </div>
              <div v-if="isShowHistory">
                <div class="col-md-12">
                  <label for="name" class="control-label required"
                    >{{ $t("propertyMaintenance.typeOfMaintenance") }}:
                  </label>
                  <span>{{ maintenaceTypeHistory }}</span>
                </div>
                <div class="col-md-12">
                  <label for="name" class="control-label required"
                    >{{ $t("propertyMaintenance.maintenanceTitle") }}:
                  </label>
                  <span>{{ titleData }}</span>
                </div>
                <div class="col-md-12">
                  <label for="name" class="control-label required"
                    >{{ $t("propertyMaintenance.price") }}:
                  </label>
                  <span>{{ currencyFormat(priceData) }}</span>
                </div>
                <div class="col-md-12">
                  <label for="name" class="control-label required"
                    >{{ $t("propertyMaintenance.assignTo") }}:
                  </label>
                  <span>{{ assignTo }}</span>
                </div>
                <div class="col-md-12">
                  <label for="name" class="control-label required"
                    >{{ $t("propertyMaintenance.implementationDate") }}:
                  </label>
                  <span>{{ implementationDate }}</span>
                </div>
                <div class="col-md-12">
                  <label for="name" class="control-label required"
                    >{{ $t("common.notes") }}:
                  </label>
                  <span
                    style="white-space: -moz-pre-wrap; 
                      white-space: pre-wrap; 
                      word-wrap: break-word;"
                  >{{ activityPlanNotes }}</span>
                </div>
                <div class="col-md-12">
                  <label for="name" class="control-label required"
                    >{{ $t("propertyMaintenance.description") }}:
                  </label>
                  <span 
                    style="white-space: -moz-pre-wrap; 
                      white-space: pre-wrap; 
                      word-wrap: break-word;"
                  >{{ description }}</span>
                </div>
              </div>
              <div
                class="col-md-12"
                v-if="
                  (isShowMaintenanceType ||
                    isShowTitle ||
                    isShowPrice ||
                    isShowDescription) && !isShowHistory
                "
              >
                <div class="form-group" v-if="isShowMaintenanceType">
                  <label for="">{{
                    $t("propertyMaintenance.typeOfMaintenance")
                  }}</label>
                  <v-select
                    class="clear"
                    :options="maintenanceTypeList"
                    :getOptionLabel="option => option.default"
                    :reduce="data => data.id"
                    label="text"
                    :placeholder="$t('propertyMaintenance.typeOfMaintenance')"
                    :clearable="false"
                    v-model="maintenanceTypeValue"
                    :disabled="disableMaintenanceType"
                  >
                    <template v-slot:option="option">
                      {{ $t(option.default) }}
                    </template>
                  </v-select>
                </div>
                <div class="form-group" v-if="isShowTitle">
                  <label for="">{{
                    $t("propertyMaintenance.maintenanceTitle")
                  }}</label>
                  <input type="text" class="form-control" v-model="titleData" />
                </div>
                <div class="form-group" v-if="isShowPrice">
                  <label for="">{{ $t("propertyMaintenance.price") }}</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="priceData"
                  />
                </div>
                <div class="form-group" v-if="isShowDescription">
                  <label for="">{{
                    $t("propertyMaintenance.description")
                  }}</label>
                  <textarea
                    name=""
                    id=""
                    cols="30"
                    rows="3"
                    class="form-control"
                    v-model="description"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" style="text-align: center">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              @click="onCloseModal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              v-if="isShowSaveBtn"
              type="button"
              class="btn btn-primary pull-right"
              @click="onSave"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
      </div>
      <lte-core-alert
        v-for="snackbar in GET_SNACK_BAR"
        :key="snackbar.id"
        :item="snackbar"
      ></lte-core-alert>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import utils from "@/lib/utils";
import LTECoreAlert from "@/components/LTESnackBar.vue";
export default {
  components: {
    "lte-core-alert": LTECoreAlert
  },
  props: {
    modalTitle: {
      type: String,
      default: () => {
        return "";
      }
    },
    // prop show ui
    isShowMaintenanceType: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    isShowTitle: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    isShowDescription: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    isShowPrice: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    isShowSaveBtn: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    isShowHistory: {
      type: Boolean,
      default: () => {
        return false;
      }
    }
  },
  data: () => ({
    isLoading: false,
    isShowOriginDetail: false,
    isShowUseInformation: false,
    assetData: {
      id: null,
      name: null,
      location: null,
      type: null,
      lastImplementationeDate: null,
      nextImplementationDate: null,
      origin: null,
      provider: null,
      assetContactPerson: null,
      assetModel: null,
      seriCode: null,
      guaranteePeriod: null,
      propertyReceiptDate: null,
      unitsUsed: null,
      status: null,
      assetUsers: null
    },
    maintenanceTypeList: [],
    maintenanceTypeValue: 1,
    disableMaintenanceType: false,
    titleData: null,
    description: null,
    priceData: null,
    activityPlanId: null,
    maintenaceTypeHistory: '',
    implementationDate: null,
    assignTo: null,
    activityPlanNotes: null
  }),
  watch: {
    ASSET_DETAIL_DATA: function() {
      let data = this.ASSET_DETAIL_DATA;
      this.assetData.id = data.id;
      this.assetData.name = data.name;
      this.assetData.location = data.location;
      this.assetData.type = data.asset_type_data.name;
      this.assetData.lastImplementationeDate = utils.formatSqlDate(data.last_maintenance_date, null, "DD-MM-YYYY");
      this.assetData.nextImplementationDate = utils.formatSqlDate(data.next_maintainance_date, null, "DD-MM-YYYY");
      this.assetData.origin = data.origin;
      this.assetData.provider = data.asset_supplier_data.name;
      this.assetData.assetContactPerson = data.asset_contact_person;
      this.assetData.assetModel = data.asset_model;
      this.assetData.seriCode = data.seri_code;
      this.assetData.guaranteePeriod = utils.formatSqlDate(data.guarantee_period, null, "DD-MM-YYYY");
      this.assetData.propertyReceiptDate = utils.formatSqlDate(data.asset_receipt_date, null, "DD-MM-YYYY");
      this.assetData.unitsUsed = data.department_data.name;
      this.assetData.status = data.asset_status_data.name;
      this.assetData.assetUsers = data.asset_user_data.full_name;
      this.maintenaceTypeHistory = !utils.isEmptyString(data.activity_plan_data.maintenance_function.name)
        ? `${data.activity_plan_data.maintenance_type.name} ${data.activity_plan_data.maintenance_function.name}`
        : data.activity_plan_data.maintenance_type.name;
      this.implementationDate = utils.formatSqlDate(data.activity_plan_data.maintainance_date, null, "DD/MM/YYYY")
      this.assignTo = data.activity_plan_data.contacter
      this.activityPlanNotes = data.activity_plan_data.notes
    },
    GET_MAINTENANCE_TYPE_LIST_DATA: function() {
      let data = this.GET_MAINTENANCE_TYPE_LIST_DATA;
      this.maintenanceTypeList = data;
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "ASSET_DETAIL_DATA",
      "GET_MAINTENANCE_TYPE_LIST_DATA"
    ])
  },
  methods: {
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    currencyFormat: function(value) {
      if (!utils.isEmptyString(value)) {
        return utils.formatNumber(value);
      }
      return null;
    },
    onCloseModal: function() {
      $(this.$refs[`modal-asset-in-activity-detail`]).modal("hide");
    },
    onShowModal: function() {
      $(this.$refs[`modal-asset-in-activity-detail`]).modal("show");
    },
    onGetData: function(
      assetId,
      activityPlanId,
      activityPlanTitle,
      maintenanceTypeId,
      activityPlanPrice,
      description
    ) {
      this.isShowOriginDetail = false;
      this.isShowUseInformation = false;
      this.assetData.id = null;
      this.activityPlanId = activityPlanId;
      this.getAssetDetail(assetId);
      if (this.isShowMaintenanceType) {
        this.getMaintenanceTypeList();
      }
      //
      this.maintenanceTypeValue = maintenanceTypeId;
      this.titleData = activityPlanTitle;
      this.description = description;
      this.priceData = activityPlanPrice;
    },
    getAssetDetail: function(assetId) {
      this.isLoading = true;
      this.onShowModal();
      let data = {
        id: assetId,
        params: {
          activityPlanId: this.activityPlanId !== undefined ? this.activityPlanId : null
        }
      }
      this.GET_ASSET_DETAIL(data)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    getMaintenanceTypeList: function() {
      this.GET_MAINTENANCE_TYPE_LIST();
    },
    validateData: function() {
      let validateResult = "OK";
      if (this.isShowTitle && utils.isEmptyString(this.titleData)) {
        validateResult = "propertyMaintenance.maintenanceTitle";
      }
      return validateResult;
    },
    onSave: function() {
      let results = this.validateData();
      if (results === "OK") {
        let data = {};
        if (this.isAssetTable) {
          data["assetList"] = this.selected;
        }
        if (this.isShowMaintenanceType) {
          data["maintenanceType"] = this.maintenanceTypeValue;
        }
        if (this.isShowTitle) {
          data["title"] = this.titleData;
        }
        if (this.isShowDescription) {
          data["description"] = this.description;
        }
        if (this.isShowPrice) {
          data["price"] = this.priceData;
        }
        if (this.activityPlanId) {
          data['activityPlanId'] = this.activityPlanId
        }
        this.$emit("emitAssetSelect", data);
      } else {
        this.showError(results);
      }
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "GET_ASSET_DETAIL",
      "GET_MAINTENANCE_TYPE_LIST"
    ])
  },
  mounted() {}
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/views/Property/AssetInActivityDetailModal.vue